import { formatDate } from '@angular/common';
import {AfterViewInit, Component, ViewChild, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Participant } from '../models/participant';
import { Researcher } from '../models/researcher';

import { Study } from '../models/study';
import { LampService } from '../services/lamp.service';
import { SleepSummary } from '../models/sleepsummary';

import { ChartDataSets } from 'chart.js';
import { FloatingChartData } from '../models/floatingChartData';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import * as pluginChartAnnotation from 'chartjs-plugin-annotation';
import { Label } from 'ng2-charts/lib/base-chart.directive';
import { Color } from 'ng2-charts/lib/color';

@Component({
  selector: 'app-sleep-log',
  templateUrl: './sleep-sensor-meq-log.component.html',
  styleUrls: ['./sleep-sensor-meq-log.component.scss']
})

export class SleepSensorMeqLogComponent implements OnInit, AfterViewInit {

  researchers: Researcher[] | undefined;
  selectedResearcher: Researcher | undefined;
  studies: Study[] | undefined;
  selectedStudy: Study | undefined;
  participants: Participant[] | undefined;
  selectedParticipant: Participant | undefined;

  loading: boolean = false;
  isJHU : boolean | false;

  sleepSummaryDisplayedColumns = ['eventDate','sleeplog_total_hours','me_wakeup_time','sleepsensor_wakeuptime','sleepsensor_source','sleepsensor_totaltime'];
  sleepSummaryDataSource: MatTableDataSource<SleepSummary> = new MatTableDataSource;
  sleepSummaryList: SleepSummary[] | undefined;
  sleepSummaryShowTable: boolean = false;

  normalize: boolean = false;
  date: Date = new Date();

  
  @ViewChild('sleepSummarySort') sleepSummarySort: MatSort;

  selectedSensorUnits: string = "";
  chartTypes: string[] = ["Bar", "Line"];
  selectedType: string = "Bar";
  floatingChartData: ChartDataSets[] | undefined;
  floatingChartLabels!: Label[];
  chartOptions = undefined;
  AllChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
         display: true,
         maxBarThickness: 70,
      }],
      yAxes: [{
        scaleLabel: {
          display: true,
          //labelString: 'Score'
        },
        ticks: {
          stepSize: 1,
          callback: function (value, index, values) {
              // Convert to 12-hour format
              let hour = (value % 12) || 12;
      
              // Determine the day part based on the first or second 12 hours
              let dayPart = value % 24 < 12 ? ' AM' : ' PM';
      
              // Add AM or PM based on the range
              return hour + dayPart;
          },
          min: 16, // Start from 4 PM
          max: 40, // End at 4 PM of the next day
          reverse: true, // Set this to true to reverse the order of the ticks
        }
      }]
    },
    elements: {
      line: {
        tension: 0,
        fill: false,
      },
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        clamp: true,
        color: 'black',
        font: {
          size: 12,
          weight: 'bold'
        },
        lineTension: 0,
        display: function (context) {
          return false; 
        }
      }
    }
  };

  chartColors: Color[] = [];
  chartLegend = true;
  chartPlugins = [pluginDataLabels, pluginChartAnnotation,
    {
      beforeInit: function (chart, options) {
        chart.legend.afterFit = function () {
          this.height += 20; // must use `function` and not => because of `this`
        };
      }
    }];

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    if (!this.sleepSummaryDataSource.sort) {
      this.sleepSummaryDataSource.sort = sort;
    }
  }
  constructor(private service: LampService, @Inject(LOCALE_ID) private locale: string, private snackBar: MatSnackBar) { 
    this.chartColors = service.getChartColors();
  }

  ngOnInit(): void {

    this.service.getResearchers().subscribe(researchers => {
      this.researchers = researchers; 
    });
  }

  ngAfterViewInit() {
    this.sleepSummaryDataSource.sort = this.sleepSummarySort!;
    this.sleepSummaryDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'eventDate': return new Date(item.eventDate);
        default: return item[property];
      }
    };    
  }

  researcherChanged() {

    this.service.getStudiesByResearcher(this.selectedResearcher?.researcherId!).subscribe(studies => {
      this.studies = studies;
    });

    this.selectedStudy = undefined;
    this.participants = undefined;
    this.selectedParticipant = undefined;
    this.resetData();
  }

  studyChanged() {
    this.participants = undefined;
    this.selectedParticipant = undefined;    
    this.service.getParticipantsByStudy(this.selectedStudy?.studyId!).subscribe(participants => {
      this.participants = participants;
    });
    this.resetData();
  }
  
  participantChanged() {
    this.resetData();
    this.selectedType="Bar";
  }
  resetData() {
    this.floatingChartData = undefined;
    this.sleepSummaryDataSource.data = [];
    this.sleepSummaryShowTable = false;
  }

  chartTypeChanged() {
  }

  populateData() {
    this.generateChart();
  }

  generateChart() {
    this.selectedSensorUnits="Hours";
    this.floatingChartData = undefined;
    this.generateGraph();

  }
  generateGraph() {
    this.loading = true;
    this.floatingChartData = undefined;
    this.chartOptions = this.AllChartOptions;
    if(this.selectedResearcher.name == 'mindLAMP-JHU')
    this.isJHU = true;
  else
    this.isJHU = false;
    this.service.getSleepSummaryForByParticipant(this.selectedParticipant?.participantId!, this.selectedParticipant?.name!, this.isJHU).subscribe({    
      next: events => {
        this.floatingChartData = new Array<ChartDataSets>();
        this.floatingChartLabels = new Array<string>();
        
        var sleepLogData = new FloatingChartData();
        var sleepSensorData = new FloatingChartData();
        var sleepMeqData = new FloatingChartData();

        sleepLogData.label = "Log Data (Hours)";
        sleepMeqData.label = "MEQ Data (Hours)"
        sleepSensorData.label = 'Sensor Data (Hours)';

        sleepSensorData.data = [];
        sleepLogData.data = [];
        sleepMeqData.data = [];

        events.forEach(event => {
          if (event.sleepsensor_total_hours == null || event.sleepsensor_total_hours == 0) {
            sleepSensorData.data!.push(null);
          } else {
            let sensorSleepTime = Math.round((this.convertUnixTimestampToCSTTime(event.sleepsensor_wakeuptime) - event.sleepsensor_total_hours + Number.EPSILON) * 100) / 100;
            sleepSensorData.data!.push([Math.round((sensorSleepTime + 24 + Number.EPSILON) * 100)/100, Math.round((this.convertUnixTimestampToCSTTime(event.sleepsensor_wakeuptime) + 24 + Number.EPSILON) * 100) / 100]);
          }

          if (event.sleeplog_total_hours == null || event.sleeplog_total_hours == 0) {
            sleepLogData.data!.push(null);
          } else {
            let logWakeTime = Math.round((event.sleeplog_wentbedtime + event.sleeplog_total_hours + Number.EPSILON) * 100) / 100;

            let logSleepTime = event.sleeplog_wentbedtime
            if(event.sleeplog_wentbedtime <= 12)
            {
              logSleepTime = logSleepTime + 24;
              logWakeTime = logWakeTime + 24;
            }
            sleepLogData.data!.push([logSleepTime, logWakeTime]);
            
          }

          if (event.me_bed_time == null && event.me_wakeup_time == null) {
            sleepMeqData.data!.push(null);
          } else {
            sleepMeqData.data!.push([this.extractStartTimeAsNumber(event.me_bed_time) + 12, this.extractStartTimeAsNumber(event.me_wakeup_time) + 24]);
          }

          this.floatingChartLabels.push(event.eventDate);
        });
        
        this.floatingChartData.push(sleepSensorData);
        this.floatingChartData.push(sleepLogData);
        this.floatingChartData.push(sleepMeqData);
   
        this.loading = false;
      },
      error: err => {
        this.floatingChartData = undefined;
        this.loading = false;
        this.openSnackBar("No Data On This Date Range", "Close");
      }
    });
  }

  extractStartTimeAsNumber(timeString: string): number | null {
    // Split the substring into hours and minutes
    const [hours, minutes] = timeString.split(':');
  
    // Convert hours and minutes to a single number format
    const startTimeNumber = parseInt(hours, 10) + parseInt(minutes, 10) / 100;
  
    return startTimeNumber;
  }

  convertUnixTimestampToCSTTime(unixTimestamp: number): number {
    // Create a new Date object using the Unix Timestamp
    const date = new Date(unixTimestamp);
  
    // Set the time zone to CST
    date.toLocaleString('en-US', { timeZone: 'America/Chicago' });
  
    // Extract hour and minute
    const hour = date.getHours();
    let minute = date.getMinutes();
  
    // Round the minute to the nearest quarter-hour
    minute = Math.round(minute / 15) * 15;
  
    // Combine hour and minute into a single number
    const time = hour + minute / 100;
  
    return time;
  }
  

  generateTable() {
    var lastVal: number = -1;

    this.sleepSummaryDataSource.data = [];
    this.loading = true;

    this.sleepSummaryShowTable = false;

    if(this.selectedResearcher.name == 'mindLAMP-JHU')
      this.isJHU = true;
    else
      this.isJHU = false;
    
    this.service.getSleepSummaryForByParticipant(this.selectedParticipant?.participantId!, this.selectedParticipant?.name!, this.isJHU).subscribe({
      next: events => {
        this.sleepSummaryList = events;
        this.sleepSummaryDataSource.data = this.sleepSummaryList;
        this.sleepSummaryDataSource.sort = this.sleepSummarySort!;
        this.loading = false;
        this.sleepSummaryShowTable = true;
      },
      error: err => {
        this.loading = false;
        this.sleepSummaryShowTable = false;
        this.openSnackBar("Error Loading Sleep Summary Table Data", "Close");
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }
}
